// https://ads.tiktok.com/help/article?aid=10028
// Deduplication: https://ads.tiktok.com/marketing_api/docs?id=1723170195197953
// TODO check all events and add more if there are any

/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load TikTok Ads event listeners
 *
 * Source: https://ads.tiktok.com/help/article/supported-standard-events
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.tiktok?.pixel_id && !pmwDataLayer?.pixels?.tiktok?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "TikTok")) pmw.loadTikTokPixel()
	}
})

const handleTikTokEvent = (eventName, payload) => {
	try {
		if (pmw.canNotFireTikTokEvent()) return
		if (!pmw.shouldFireBrowserPixel(payload, "tiktok")) return

		// Get TikTok data from unified payload
		const tiktokData = payload.pixels?.tiktok;
		if (!tiktokData) {
			pmw.console.warn(`TikTok event data not found in payload for ${eventName}`);
			return;
		}

		ttq.track(
			tiktokData.event,
			tiktokData.properties,
			{event_id: tiktokData.event_id},
		)

		pmw.console.log(`TikTok Pixel: ${tiktokData.event} event sent`, tiktokData)

	} catch (e) {
		console.error(e)
	}
}

const tikTokEvents = [
	"pmw:pixel:view-item",
	"pmw:pixel:view-category",
	"pmw:pixel:add-to-cart",
	"pmw:pixel:add-to-wishlist",
	"pmw:pixel:search",
	"pmw:pixel:begin-checkout",
	"pmw:pixel:add-payment-info",
	"pmw:pixel:place-order",
	"pmw:pixel:purchase", // Browser pixel fires here, server-side handled via PHP Events API
]

tikTokEvents.forEach(eventName => {
	pmw.bus.on(eventName, handleTikTokEvent.bind(null, eventName))
})
